import type { CategoryFormFieldProps } from '@zealth/core/formFields/types'

import { DropdownFormField } from './DropdownFormField'

export const CategoryFormField = ({
  categoryIds,
  label,
  optional,
}: CategoryFormFieldProps) => {
  const options = categoryIds.map(id => ({ value: id, label: id }))

  return (
    <DropdownFormField
      options={options}
      label={label ?? ''}
      optional={optional}
    />
  )
}
